import { Pipe, PipeTransform } from '@angular/core';
import { formatDistanceToNowStrict } from 'date-fns';

@Pipe({ name: 'relativeTime' })
export class RelativeTimePipe implements PipeTransform {
	transform(value: Date | string): string {
		if (!value) {
			return '';
		}

		const date = value instanceof Date ? value : new Date(value);

		if (isNaN(date.getTime())) {
			return 'Invalid date';
		}

		return formatDistanceToNowStrict(date, { addSuffix: true });
	}
}
